import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ListsForResourceComponent } from './lists-for-resource.component';
import { ListsForResourceEffects } from './lists-for-resource.effects';
import { listsForResourceReducer } from './lists-for-resource.reducer';
import {
  STATE_FEATURE_LISTS_FOR_RESOURCE,
  getInitialListForResourceState,
} from './lists-for-resource.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ListsForResourceEffects]),
    StoreModule.forFeature(
      STATE_FEATURE_LISTS_FOR_RESOURCE,
      listsForResourceReducer,
      {
        initialState: getInitialListForResourceState,
      },
    ),
    RouterModule,
  ],
  declarations: [ListsForResourceComponent],
  exports: [ListsForResourceComponent],
  providers: [],
})
export class ListsForResourceModule {}
